import { utilHelper } from "../../_helpers";
import {SUCCESSFUL_TRANSLATION_LABEL} from "../../../components/i18n/i18n";

const relativeUrl = 'api/afi';

export const afiService = {
    search,
    saveItem,
    updateItem,
    deleteItem,
    getOptions,
    translate,
};

//search
function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data:data, showAlert:false })
}

//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

//update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data:data });
}

//delete
function deleteItem(id,fbDB) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE',{});
}

function getOptions(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/getOptions`, 'POST', { data:data, showAlert:false })
}

function translate(id, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate/${id}`, 'POST', { data: data, message:SUCCESSFUL_TRANSLATION_LABEL });
}